import React from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home"; 
import Web from "./pages/Web";
import About from "./components/About/About";
import Optimisation from "./pages/Optimisation";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueDeConfidentialit";
import CGV from "./pages/Cgv";

export default function App(){
    return(
        <BrowserRouter>
        <Header/>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/web" element={<Web />}/>
            <Route path="/about" element={<About/>}/>
            <Route path="/optimisation" element={<Optimisation/>}/>
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />}/>
            <Route path="/conditions-generales-vente" element={<CGV/>}/>

        </Routes>
        <Footer/>
        </BrowserRouter>
    )
}


